import React from "react";
import NavbarComponent from "../Homepage/components/NavbarComponent/NavbarComponent";
import Footer from "../Homepage/components/Footer/Footer";
import "./DemoPage.css";

function DemoPage() {
  return (
    <>
      <NavbarComponent />

      <div className="demo-page">

        <h2 className="demo-title">
          Schedule Demo For{" "}
          <span className="demo-highlight">
            Solar CRM
          </span>
        </h2>

        <div className="demo-frame-wrapper">

          <iframe
            src="https://meet.brevo.com/team-one-place-solar/30-minute-meeting"
            className="demo-iframe"
            scrolling="no"
            title="Brevo Meeting"
          ></iframe>

        </div>

      </div>

      <Footer />
    </>
  );
}

export default DemoPage;